<script lang="jsx">
import BuyNow from './buy-now.vue';
import Add2Cart from './add.vue';
import Edit from './edit.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  name: 'DIDConfig',
  mixins: [planPropsMixin],

  render() {
    const props = {...this.$props, ...this.$attrs};

    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...props} />;
    if (this.$context.is.add2cart) return <Add2Cart {...props} />;
    if (this.$context.is.edit) return <Edit {...props} />;
    return null;
  },
};
</script>
